import React, { useEffect, useState } from "react";
import DashboardPieChart from "../../CommonComponents/Dashboard/DashboardPieChart/DashboardPieChart";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";

// import { Container } from './styles';

function DeviceTypeDistribution({
  isApiPlatformOverviewRunning,
  deviceTypeData,
  // isPlatformOverviewSectionFirstRender,
  // getPlatformOverviewData,
}) {


  const colorOptions = ["#E74C3C", "#F39C12", "#F1C40F", "#71BF8A", "#3498DB"];
  const pieData = Object.keys(deviceTypeData?.percentage_distribution)?.map(
    (device, index) => ({
      device: device,
      count: Math.round(
        (deviceTypeData.percentage_distribution[device] *
          deviceTypeData.total_logins) /
          100
      ),
      color: colorOptions[index],
    })
  );

  return (
    <DashboardPieChart
      title="Device type distribution"
      pieData={pieData}
      isApiRunning={isApiPlatformOverviewRunning}
    />
  );
}

export default DeviceTypeDistribution;
